import React, { useEffect, useState } from "react";
import {  X } from "lucide-react";
import AddEquipmentModal from "../components/CompanyEquipments/AddEquipmentModal";
import { Modal, Box } from "@mui/material";
import api from "../axios/api";
import PageHeader from "../componentsII/PageHeader";
import boiler from "../images/boilder.png";
import CustomCard from "../componentsII/Card"
import CompanyEquipmentDetailModal from "../components/CompanyEquipments/CompanyEquipmentDetailModal";
import { useSelector } from "react-redux";
import SettingsModal from "../components/SettingsModal";

import { useDispatch } from "react-redux";
import { fetchCounts } from '../redux/slices/countsSlice';

const CompanyEquipments = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [equipments, setEquipments] = useState([]);
  const [inactiveEquipments, setInactiveEquipments] = useState([]);
  const [activeEquipments, setActiveEquipments] = useState([]);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [detailModalData, setDetailModalData] = useState({});
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);

  const user = useSelector((state) => state.user.user);
  const year = useSelector((state) => state.user.selectedYear);

  const handleOpenSettingsModal = () => {setIsSettingsModalOpen(true);};
  const handleCloseSettingsModal = () => {fetchEquipments();setIsSettingsModalOpen(false)};

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleOpenDetailModal = () => setIsDetailModalOpen(true);
  const handleCloseDetailModal = () => setIsDetailModalOpen(false);

  useEffect(() => {
    fetchEquipments();
  }, []);

  const fetchEquipments = async () => {
    try {
      const response = await api.get(
        `/equipment/companyequipment?company_id=${user.company.id}&year_id=${year.id}`
      );
      if (response.data.data) {
        const equipments = response.data.data.filter(item => item.is_active === 1);
        setEquipments(equipments);

        const activeEquipments = response.data.data.filter(item => item.is_active === 1).map(({ value, label, equipment_type_details,comp_location_details, ...rest }) => ({id:value,name: label,details: `${equipment_type_details.equipment_type_name}-${comp_location_details.comp_location_name}`,...rest,}));
        const inActiveEquipments = response.data.data.filter(item => item.is_active === 0).map(({ value, label, equipment_type_details,comp_location_details, ...rest }) => ({id:value,name: label,details: `${equipment_type_details.equipment_type_name}-${comp_location_details.comp_location_name}`,...rest,}));
        setInactiveEquipments(inActiveEquipments);
        setActiveEquipments(activeEquipments); 
      }
      dispatch(fetchCounts({
        companyId: user.company.id,
        yearId: year.id
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <PageHeader
      title="Company Equipments"
      text={[
        "Define your base year to establish a starting point for measuring progress and set target years with specific reduction goals.",
        "This data will be used throughout the system to track and visualize your company's environmental impact over time.",
      ]}
      buttonTitle="Add Equipments"
      handleClick={handleOpenModal}
      showBtn2={true}
      disableBtn2 = {!year.is_copied}
      handleBtn2Click={handleOpenSettingsModal}
      buttonTitle2="Copy Equipments"
    >
      {equipments.length === 0 ? (
        // Empty State
        <div className="text-center py-16 bg-gray-50 rounded-lg">
          <img
            src="/vectors/equipments.jpg"
            alt="No Data"
            className="w-80 h-80 mx-auto text-gray-400 mb-4"
          />
          <h3 className="text-xl font-medium text-gray-600 mb-2">
            No Equipments Found
          </h3>
          <p className="text-gray-500">
            Add your first equipment to get started
          </p>
        </div>
      ) : (
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="overflow-x-auto border grid grid-cols-4 gap-4 p-4">
            {equipments.map((item) => {
              return (
                <CustomCard
                  image={boiler}
                  title={item.label}
                  subtitleI={`${item?.equipment_type_details?.equipment_type_name}`}
                  subtitleII={item?.comp_location_details?.comp_location_name}
                  // subtitleIII={`${item?.consume_fuel ? "Yes" : "No"}`}
                  onClick={() => {
                    handleOpenDetailModal();
                    setDetailModalData({ ...item, boiler });
                  }}
                />
              );
            })}
          </div>
        </div>
      )}

      <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        aria-labelledby="add-location-modal-title"
        aria-describedby="add-location-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "auto",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
            display: "relative",
          }}
        >
          {/* Close Button */}
          <button
            onClick={handleCloseModal}
            className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
            aria-label="Close"
          >
            <X size={24} />
          </button>

          <AddEquipmentModal refetch={fetchEquipments} onClose={handleCloseModal} />
        </Box>
      </Modal>
      <Modal
        open={isDetailModalOpen}
        onClose={handleCloseDetailModal}
        aria-labelledby="add-location-modal-title"
        aria-describedby="add-location-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "auto",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
            display: "relative",
          }}
        >
          <button
            onClick={handleCloseDetailModal}
            className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
            aria-label="Close"
          >
            <X size={24} />
          </button>
          <CompanyEquipmentDetailModal equipments={equipments} detailModalData={detailModalData} refetch={fetchEquipments} handleCloseMainDetailModal={handleCloseDetailModal} />
        </Box>
      </Modal>
      <Modal
        open={isSettingsModalOpen}
        onClose={handleCloseSettingsModal}
        aria-labelledby="add-location-modal-title"
        aria-describedby="add-location-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "auto",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
            display: "relative",
          }}
        >
          <button
            onClick={handleCloseSettingsModal}
            className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
            aria-label="Close"
          >
            <X size={24} />
          </button>
          <SettingsModal
            ActiveList={activeEquipments}
            InactiveList={inactiveEquipments}
            HelperText={[`Below is the list of vehicles that are active for ${year.start_year} and the list of Equipments available from other reporting years but inactive for the current reporting year.`, "You can add new Equipments to this reporting year from your main Equipments page"]}
            ModalFor="Equipments"
            Title="Configure Equipments"
            EmptyActiveText="No Active Equipments"
            EmptyInactiveText="No Inactive Equipments"
            EmptyActiveImage={"/vectors/equipments.jpg"}
            EmptyInactiveImage={"/vectors/equipments.jpg"}
            handleCancel={handleCloseSettingsModal}
          />
        </Box>
      </Modal>
    </PageHeader>
  );
};

export default CompanyEquipments;
